"use client";
import Image from "next/image";
import Link from "next/link";
import { Box, Stack, SimpleGrid } from "@chakra-ui/react";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading } from "@/elements";
import { TECH_PARTNERS_CONSTANTS } from "./techPartners.constants";

const TechPartners = () => {
  const HeadingVariant = useHeadingVariant();
  const { title, list } = TECH_PARTNERS_CONSTANTS;
  return (
    <Stack gap={10}>
      <Heading as="h3" variant={HeadingVariant} textAlign={"center"} px={2}>
        {title}
      </Heading>
      <Stack borderRadius={"8px"} className="brand-shadow" gap={8} py={10}>
        <SimpleGrid
          columns={{ base: 6, md: 8 }}
          columnGap={{ base: 3, sm: 4, md: 5 }}
          justifyContent={"center"}
          alignItems={"center"}
          rowGap={10}
          p={{ base: 3, md: 5 }}
        >
          {list.map((partner, index) => {
            return (
              <Box
                key={index}
                asChild
                position="relative"
                maxW="130px"
                width="100%"
                height="65px"
              >
                <Link href={partner.href} target="_blank" rel="noopener noreferrer">
                  <Image
                    src={partner.image}
                    alt={partner.name}
                    fill
                    sizes="(min-width: 62em) 130px, (min-width: 30em) 100px, 80px"
                    style={{ objectFit: "contain", objectPosition: "center" }}
                    loading="lazy"
                  />
                </Link>
              </Box>
            );
          })}
        </SimpleGrid>
      </Stack>
    </Stack>
  );
};

export default TechPartners;
